/* Dynamic Plot code copyright 2018 (c) Tuva Labs Inc. */
import { PlotElement } from "./plotElement";

/**
 * Grid Lines Element: model and controller for static grid lines that follow the origin and axis tick marks.
 * Added to Dyn.PlotShaper's list of plot elements, to make a plot.
 * created by cmiller
 */

// import {Dyn} from '../../dynDataSet/dynMiscellany';

export const wrapDynGridLinesElement = function(Dyn) {

//============================

    class GridLinesElement extends PlotElement{
        /**
         * Dyn.GridLinesElement()
         * Control the appearance and disappearance of the grid lines, which are actually drawn by the Dyn.AxisView objects.
         * @constructor
         */
        constructor() {
            super(Dyn);
            this.initElement( {
                priority: Dyn.EPlotPriority.kPriorityPlotFunction,
                replaceType: Dyn.EPlotControl.kControlsGridLines,
                primaryType: Dyn.EPlotControl.kControlsGridLines,
                otherControls: [
                    Dyn.EPlotControl.kControlsMargins // to update axis when this element is added or removed
                ]
            }, Dyn );

        }
        get kUndoAction(){ return 'Show/Hide Grid Lines'; }


        /** Update the plot's axis model, removing any elements incompatible with this PlotElement. */
        calcAxis ( ioWhatChanged, subViewRef ) {
            // tell the axes to show the grid lines
            // NOTE: other plot elements that are shapers will clear the grid lines with the setPlotSpecificOptions() call,
            // but this plotElement should be highest priority so it gets the last word.  This also is how the grid
            // lines get cleared with this element is removed.
            subViewRef.xAxisView.showHideGridLines( true );
            subViewRef.yAxisView.showHideGridLines( true );
        }
    } // class GridLinesElement
    Dyn.GridLinesElement = GridLinesElement;
    Dyn.PlotElemHelper.registerType( Dyn.EPlotControl.kControlsGridLines, Dyn.GridLinesElement );
} // wrap Dyn
